import React from 'react';
import * as Indicadores from '../constantes/IndicadoresTitulosEquipos.js';
import * as Iconos from '../UI/Iconos.js';
import styles from './Iconos.module.css';

export const IconoTitulo = (props) => {
  const objeto = props.objeto;

  let source = null;
  let alt = null;
  if (objeto && objeto.tituloObtenido) {
    if (objeto.tituloObtenido === Indicadores.CAMPEON) {
      source = Iconos.campeon;
      alt = 'Campeón';
    } else if (objeto.tituloObtenido === Indicadores.CAMPEON_COMPARTIDO) {
      source = Iconos.campeonCompartido;
      alt = 'Campeón Compartido';
    } else if (objeto.tituloObtenido === Indicadores.SUBCAMPEON) {
      source = Iconos.subCampeon;
      alt = 'Subcampeón';
    } else if (objeto.tituloObtenido === Indicadores.MEDALLA_ORO) {
      source = Iconos.medallaOro;
      alt = 'Medalla de Oro';
    } else if (objeto.tituloObtenido === Indicadores.MEDALLA_PLATA) {
      source = Iconos.medallaPlata;
      alt = 'Medalla de Plata';
    } else if (objeto.tituloObtenido === Indicadores.MEDALLA_BRONCE) {
      source = Iconos.medallaBronce;
      alt = 'Medalla de Bronce';
    }
  }

  return (
    <React.Fragment>
      {source && (
        <img
          className={`${styles.iconoTitulo}`}
          src={source}
          id={objeto.id}
          key={alt + objeto.id}
          alt={alt}
        />
      )}
    </React.Fragment>
  );
};

export default IconoTitulo;
